import moment from "moment";
import React, { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import MyYuukke from "../../../api/MyYuukke";
import RazorPay from "../../../components/RazorPay";
import {
  getSubscriptionList,
  getSubscriptionStatus,
  getUserSlots,
} from "../../../redux/actions/calendarAction";
import SubscriptionCard from "../../PremiumBadges/SubscriptionCard";

const SubscriptionList = ({ onBack }) => {
  const {
    subscriptionList,
    subscriptionStatus,
    subscriptionDetails,
    expiryDate,
  } = useSelector((state) => state.event);
  const { loginDetails } = useSelector((state) => state.loginDetailsApi);

  const [state, setState] = useState({
    loader: false,
    paymentAmount: null,
    paymentSuccess: false,
    subscriptionId: 0,
    lifeTimeOffer: true,
  });

  const [autoRenew, setAutoRenew] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSubscriptionList("service"));
  }, []);

  const updateState = (name, value) => {
    setState((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const openPaymentPage = (prize, id) => {
    setAutoRenew(true);

    if (prize === 0) {
      savePaymentInfo(id === null || id === undefined ? 1 : id);
    } else {
      setState((previous) => ({
        ...previous,
        paymentAmount: prize,
        subscriptionId: id,
      }));
    }
  };

  const reloadDashboard = (title, text) => {
    Swal.fire({
      icon: "success",
      title,
      text,
      showConfirmButton: false,
      timer: 1500,
      timerProgressBar: true,
      allowOutsideClick: false,
    }).then(() => {
      window.location.reload();
    });
  };

  // Called only once every async step (payment save, calendar create,
  // redux refresh) has actually settled — never before.
  const updatePaymentStatus = async (status) => {
    if (status === "dismiss") {
      Swal.fire({
        icon: "error",
        title: "Payment updating failed!",
        text: "If your money debited in bank account ,please contact our team  +91 04446314646",
        showConfirmButton: true,
      }).then(() => {
        setState((previous) => ({
          ...previous,
          paymentSuccess: false,
          paymentAmount: null,
        }));
      });
      return;
    }

    // Keep the blocking loader up while we wait on the redux refresh —
    // Payment.js has already finished payment save + calendar creation
    // by the time this is called, but the slot/status refresh here
    // still needs to finish before it's safe to reload.
    updateState("loader", true);

    try {
      await Promise.all([
        dispatch(getUserSlots()),
        dispatch(getSubscriptionStatus("calender")),
      ]);
    } catch (err) {
      console.error("Post-payment refresh failed:", err);
      // Non-fatal — proceed to reload anyway since payment itself succeeded;
      // the reload will re-fetch this data fresh regardless.
    }

    setState((previous) => ({
      ...previous,
      paymentSuccess: true,
      paymentAmount: null,
      loader: false,
    }));

    reloadDashboard(
      "Subscription activated!",
      "Your plan is now active. Reloading your dashboard..."
    );
  };

  // Free (₹0) plan path never goes through Payment.js — everything here
  // (subscription save, calendar creation, redux refresh) must be awaited
  // in sequence before reloadDashboard fires.
  const savePaymentInfo = async (id) => {
    updateState("loader", true);

    const data = {
      subscriptionId: id,
    };

    try {
      const res = await MyYuukke.addUserSubscription(data);
      console.log("response", res);

      await Promise.all([
        dispatch(getUserSlots()),
        dispatch(getSubscriptionStatus("calender")),
      ]);

      if (loginDetails?.userId) {
        try {
          await MyYuukke.createCalendarDetails(loginDetails.userId);
        } catch (err) {
          console.error("createCalendarDetails failed:", err);
          // Non-fatal — subscription itself is already saved.
        }
      }

      updateState("loader", false);

      reloadDashboard(
        "You're all set!",
        "Your free plan is active. Reloading your dashboard..."
      );
    } catch (e) {
      console.log("e", e);
      updateState("loader", false);
    }
  };

  const selectedPlan = subscriptionList?.find(
    (item) => item.id === state.subscriptionId
  );

  return (
    <BlockUi
      tag="div"
      message="Loading, please wait"
      style={{ minHeight: "134px" }}
      className="wallLoadingPage"
      blocking={state.loader}
    >
      <h4
        className="p-3 mt-2 mb-2   heading-h4-v2"
        style={{ borderBottom: "1px solid #80808063" }}
      >
        <IoArrowBackCircleOutline
          onClick={() => onBack()}
          className="h-auto  mr-3 svg-icons"
          style={{
            width: "2rem",
          }}
        />
        Subscription plans
      </h4>

      {subscriptionStatus ? (
        <>
          <section className="pt-5 p-5">
            <div className="alert alert-primary m-3" role="alert">
              {loginDetails?.isLifeTimeSubscription
                ? "You're a Lifetime Premium Member 💎"
                : `Your Premium Membership Plan Expires on ${moment(expiryDate)
                    .locale("en")
                    .format("lll")}`}
            </div>
          </section>
        </>
      ) : (
        <>
          {state.paymentAmount && selectedPlan && (
            <div
              style={{
                background: !selectedPlan.razorpayPlanId ? "#f0fdf4" : "#fff8f9",
                border: !selectedPlan.razorpayPlanId
                  ? "1px solid #bbf7d0"
                  : "1px solid #f0dde3",
                padding: "15px",
                borderRadius: "10px",
                margin: "1rem",
              }}
            >
              <h4
                style={{
                  fontSize: "16px",
                  color: !selectedPlan.razorpayPlanId ? "#15803d" : "#7a0024",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                Payment Details for {selectedPlan.subscriptionName}
              </h4>

              {!selectedPlan.razorpayPlanId ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span style={{ fontSize: "24px" }}>🎉</span>
                  <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                    <span style={{ fontSize: "0.95rem", color: "#15803d", fontWeight: 600 }}>
                      Pay once. Access confirmed.
                    </span>
                    <span style={{ fontSize: "0.8rem", color: "#166534", marginTop: "2px" }}>
                      This is a one-time payment. There are no automatic renewals or hidden
                      charges for this plan.
                    </span>
                  </div>
                </div>
              ) : (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    cursor: "pointer",
                    background: autoRenew ? "#ffeef3" : "#fff",
                    padding: "12px 15px",
                    borderRadius: "8px",
                    border: autoRenew ? "1px solid #7a0024" : "1px solid #e5e7eb",
                    transition: "all 0.2s",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={autoRenew}
                    onChange={(e) => setAutoRenew(e.target.checked)}
                    style={{ width: "20px", height: "20px", accentColor: "#7a0024", cursor: "pointer" }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                    <span
                      style={{
                        fontSize: "0.95rem",
                        color: autoRenew ? "#7a0024" : "#4b5563",
                        fontWeight: 600,
                      }}
                    >
                      Enable Auto-Renewal (Recommended)
                    </span>
                    <span style={{ fontSize: "0.8rem", color: "#6b7280", marginTop: "2px" }}>
                      We will automatically bill you when this plan expires so your service is
                      never interrupted. Uncheck to pay manually next time.
                    </span>
                  </div>
                </label>
              )}
            </div>
          )}

          {state.paymentAmount && (
            <RazorPay
              email={loginDetails.email}
              name={loginDetails.dName}
              userId={loginDetails.userId}
              contactNumber={loginDetails.phoneNumber}
              subscriptionId={state.subscriptionId}
              amount={state.paymentAmount}
              type={"Service-Register"}
              updatePaymentStatus={updatePaymentStatus}
              selectedPlan={selectedPlan}
              autoRenew={autoRenew}
            />
          )}

          <div className="d-flex flex-wrap g-1 p-4">
            {subscriptionList.map((item, index) => (
              <SubscriptionCard
                data={item}
                index={index}
                key={item.id ?? index}
                selectedTeam={openPaymentPage}
              />
            ))}
          </div>
        </>
      )}
    </BlockUi>
  );
};

export default SubscriptionList;